import { motion } from 'framer-motion'
import { AlertTriangle } from 'lucide-react'

interface FormErrorProps {
  message: string
}

export default function FormError({ message }: FormErrorProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4"
    >
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <AlertTriangle className="h-5 w-5 text-red-500" />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-red-800 dark:text-red-400">
            Error
          </h3>
          <div className="mt-1 text-sm text-red-700 dark:text-red-300">
            {message}
          </div>
        </div>
      </div>
    </motion.div>
  )
}